/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { ExpenseCategory } from './';
import {
    ExpenseCategoryFromJSON,
    ExpenseCategoryFromJSONTyped,
    ExpenseCategoryToJSON,
} from './';
import type { TaxRate } from './';
import {
    TaxRateFromJSON,
    TaxRateFromJSONTyped,
    TaxRateToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateExpenseRequest
 */
export interface CreateExpenseRequest {
    /**
     * 
     * @type {ExpenseCategory}
     * @memberof CreateExpenseRequest
     */
    category: ExpenseCategory;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    receiptId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    receiptName?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateExpenseRequest
     */
    receiptUploadDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateExpenseRequest
     */
    purchaseDate: Date;
    /**
     * 
     * @type {Currency}
     * @memberof CreateExpenseRequest
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof CreateExpenseRequest
     */
    amountWithoutTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof CreateExpenseRequest
     */
    amountWithTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof CreateExpenseRequest
     */
    distance?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateExpenseRequest
     */
    distanceRate?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateExpenseRequest
     */
    vatDeductible: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateExpenseRequest
     */
    vatDeductibleRate?: number;
    /**
     * 
     * @type {Array<TaxRate>}
     * @memberof CreateExpenseRequest
     */
    appliedFreelancerTaxes?: Array<TaxRate>;
    /**
     * 
     * @type {number}
     * @memberof CreateExpenseRequest
     * @deprecated
     */
    freelancerVat?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateExpenseRequest
     */
    amountTotal: number;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    supplier: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    description?: string;
}

/**
 * Check if a given object implements the CreateExpenseRequest interface.
 */
export function instanceOfCreateExpenseRequest(value: object): value is CreateExpenseRequest {
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('purchaseDate' in value) || value['purchaseDate'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('amountWithoutTaxes' in value) || value['amountWithoutTaxes'] === undefined) return false;
    if (!('amountWithTaxes' in value) || value['amountWithTaxes'] === undefined) return false;
    if (!('vatDeductible' in value) || value['vatDeductible'] === undefined) return false;
    if (!('amountTotal' in value) || value['amountTotal'] === undefined) return false;
    if (!('supplier' in value) || value['supplier'] === undefined) return false;
    return true;
}

export function CreateExpenseRequestFromJSON(json: any): CreateExpenseRequest {
    return CreateExpenseRequestFromJSONTyped(json, false);
}

export function CreateExpenseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateExpenseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'category': ExpenseCategoryFromJSON(json['category']),
        'receiptId': json['receiptId'] == null ? undefined : json['receiptId'],
        'receiptName': json['receiptName'] == null ? undefined : json['receiptName'],
        'receiptUploadDate': json['receiptUploadDate'] == null ? undefined : (new Date(json['receiptUploadDate'])),
        'purchaseDate': (new Date(json['purchaseDate'])),
        'currency': CurrencyFromJSON(json['currency']),
        'amountWithoutTaxes': json['amountWithoutTaxes'],
        'amountWithTaxes': json['amountWithTaxes'],
        'distance': json['distance'] == null ? undefined : json['distance'],
        'distanceRate': json['distanceRate'] == null ? undefined : json['distanceRate'],
        'vatDeductible': json['vatDeductible'],
        'vatDeductibleRate': json['vatDeductibleRate'] == null ? undefined : json['vatDeductibleRate'],
        'appliedFreelancerTaxes': json['appliedFreelancerTaxes'] == null ? undefined : ((json['appliedFreelancerTaxes'] as Array<any>).map(TaxRateFromJSON)),
        'freelancerVat': json['freelancerVat'] == null ? undefined : json['freelancerVat'],
        'amountTotal': json['amountTotal'],
        'supplier': json['supplier'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateExpenseRequestToJSON(value?: CreateExpenseRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'category': ExpenseCategoryToJSON(value['category']),
        'receiptId': value['receiptId'],
        'receiptName': value['receiptName'],
        'receiptUploadDate': value['receiptUploadDate'] == null ? undefined : ((value['receiptUploadDate']).toISOString()),
        'purchaseDate': ((value['purchaseDate']).toISOString().substring(0,10)),
        'currency': CurrencyToJSON(value['currency']),
        'amountWithoutTaxes': value['amountWithoutTaxes'],
        'amountWithTaxes': value['amountWithTaxes'],
        'distance': value['distance'],
        'distanceRate': value['distanceRate'],
        'vatDeductible': value['vatDeductible'],
        'vatDeductibleRate': value['vatDeductibleRate'],
        'appliedFreelancerTaxes': value['appliedFreelancerTaxes'] == null ? undefined : ((value['appliedFreelancerTaxes'] as Array<any>).map((v) => TaxRateToJSON(v))),
        'freelancerVat': value['freelancerVat'],
        'amountTotal': value['amountTotal'],
        'supplier': value['supplier'],
        'description': value['description'],
    };
}

